import React, { Component, useState, useEffect } from "react";
import Select from "react-select";
import {NavLink, useNavigate, useSearchParams, Navigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Full_Calendar from './full-calendar';
import axios from "axios";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HomeBanner from "../images/feature-banner.png";
import Arrow from "../images/Down_Arrow_3_.svg"
import RedStar from "../images/star-red.svg"
import GreyStar from "../images/star-grey.svg"
import { changeLanguage } from "i18next";



function SearchRes(props) { 
  console.log("************************", props);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  console.log('searchParams', searchParams)
  
  //const zodiac = searchParams.get('zodiac');
  

  const { t, i18n } = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [clicked, setClicked] = useState('');
  const [clickedType, setclickedType] = useState('');
  const [searchData, setSearchData] = useState([]);  
  const [searchExtraData, setSearchExtraData] = useState([]);
  


  const [zLuck, setZLuck] = useState([]); // Zodiac luck
  const [days, setDays] = useState([]); // Zodiac luck


  ///////////////////////// SEARCH /////////////////////////
  const [searchTitle, setSearchTitle] = useState('');
  const [searchSDate, setSearchSDate] = useState(new Date());
  const [searchEDate, setSearchEDate] = useState(new Date());
  var zodiac = searchParams.get('zodiac');
  if(zodiac) {
    zodiac = zodiac.split(',');
  }
  const [selectedIds, setSelectedIds ] = useState([zodiac]);
  var seldays = searchParams.get('days');
  var seldaysURL = []
  if(seldays) {
    seldays = seldays.split(',');
    for (let i = 0;i <seldays.length; i++) {
      seldaysURL = [...seldaysURL,seldays[i]]
    };
  }
  
  const [selectedDays, setSelectedDays ] = useState([]); 
  const [allEvents, setAllEvents] = useState([]);  

  ///////////////////////// SEARCH /////////////////////////

  
  


  
  
  const getAuspiciousDataByDate = (all_params) => {
    //const postData = {'activities': searchTitle, 'from_date': searchSDate, 'to_date': searchEDate, 'zodiac': '' };
    
    
    setClicked('noaction');
    axios.get(process.env.REACT_APP_API_KEY+"api/auspicious-search",
    {
      params: all_params,
      headers: {
      "Content-type": "Application/json",
      "Accept": "Application/json",
      "Authorization": `Bearer `+token,
      "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      
      var reData = res.data; 
      
      if(reData.status == true){ // ?.
        console.log('reFullData',reData);
        setSearchData(reData?.data);
        setSearchExtraData(reData?.extraData);
        
       
      } else {
        swal("Oops", reData?.message, "error");
      }
      
      setClicked('');
    }).catch (error => {
      
      if(error?.response?.status == 401 && error?.response?.data?.message == 'Unauthenticated.') {
         localStorage.removeItem("token")
         localStorage.removeItem("userData")
         localStorage.removeItem("fname")
         localStorage.removeItem("lname")
         localStorage.removeItem("nameImage")
         localStorage.removeItem("otpCounter")
         localStorage.removeItem("USERLOGIN")
         navigate("/");
      } else {
        swal("Oops", "Something went wrong.", "error");
      }
      setClicked('');
      
     
    })
    

      
  } /* function close */

  const handleChangeDays = (event) => {
    const checked_id = event.target.value;
    if(event.target.checked){
      setSelectedDays([...selectedDays,checked_id])
    } else{
      setSelectedDays(selectedDays.filter(id=>id !== checked_id))
    }
    console.log("ItemCheckDays", selectedDays)
  }

  const handleChange = (event) => {
    const checkedId = event.target.value;
    if(event.target.checked){
     setSelectedIds([...selectedIds,checkedId])
    } else{
     setSelectedIds(selectedIds.filter(id=>id !== checkedId))
    }
    console.log("ItemCheck1", selectedIds)
  }

  function updateQueryStringParameter (uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  const serchAuspicious = () => {
    
    setclickedType('searchAuspicious');
    setClicked('noaction');
    console.log('SSS: ');
    console.log(searchTitle);
    console.log(searchSDate);
    console.log(searchEDate);
    console.log(selectedDays);

    var newDate =  new Date(searchEDate);
    var php_date = newDate.getFullYear()+'-'+(newDate.getMonth()+1); //+'-'+newDate.getDate();

    var newSDate =  new Date(searchSDate);
    var php_s_date = newSDate.getFullYear()+'-'+(newSDate.getMonth()+1); //+'-'+newSDate.getDate();
   
    var currentUrl = window.location.href;
    currentUrl = updateQueryStringParameter(currentUrl,'activities', searchTitle );
    currentUrl = updateQueryStringParameter(currentUrl,'from_date', php_s_date );
    currentUrl = updateQueryStringParameter(currentUrl,'to_date', php_date );
    currentUrl = updateQueryStringParameter(currentUrl,'zodiac', selectedIds );
    currentUrl = updateQueryStringParameter(currentUrl,'days', selectedDays );
    //var updatedUrl = currentUrl.split('?')[0] + '?' + urlParams.toString();
    console.log('currentUrl', currentUrl);
    window.history.replaceState({}, '', currentUrl);

    var paramsurl = {
      activities: searchTitle,
      from_date: php_s_date,
      to_date: php_date,
      zodiac: selectedIds,
      days: selectedDays 
    };
    
    getAuspiciousDataByDate(paramsurl)
    //setClicked('');
  }
  const serchData = () => {
    navigate("/features");
  }
  


  const getURL = (seldate) =>{
      return (
        'features?seldate='+seldate
      );
    };


return (
  <>
    <div className="feature features-header">
      <h1>Page Loading...</h1>
    </div>
  </>
);
}

export default SearchRes;
